module.exports = __webpack_public_path__ + "img/logo.c72653a4.png";